import * as types from '../actionTypes/championActionTypes';

const INITIAL_STATE = {
  signingUp: false,
  signingUpError: '',

  authenticating: false,
  authenticatingError: '',

  gettingChampionData: false,
  gettingChampionDataError: '',
  championData: null,

  submittingChampionSocialForm: false,
  submittingChampionSocialFormError: '',
  submittingChampionSocialFormSuccess: false,

  gettingChampionProfileData: false,
  gettingChampionProfileDataError: '',
  championProfileData: null,

  gettingChampionProfilePools: false,
  gettingChampionProfilePoolsError: '',
  championProfilePools: [],

  gettingChampionPoolTiles: false,
  gettingChampionPoolTilesError: '',
  championPoolTiles: [],

  submittingStakeState: {},
  championHasOwnPool: true, // true to disable create hpool button for first load
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SIGN_UP_CHAMPION_REQUEST:
      return {
        ...state,
        signingUp: true,
        signingUpError: '',
      };

    case types.SIGN_UP_CHAMPION_SUCCESS:
      return {
        ...state,
        signingUp: false,
        signingUpError: '',
      };

    case types.SIGN_UP_CHAMPION_FAILURE:
      return {
        ...state,
        signingUp: false,
        signingUpError: payload,
      };

    case types.LOG_IN_CHAMPION_REQUEST:
      return {
        ...state,
        authenticating: true,
        authenticatingError: '',
      };

    case types.LOG_IN_CHAMPION_SUCCESS:
      return {
        ...state,
        authenticating: false,
        authenticatingError: '',
      };

    case types.LOG_IN_CHAMPION_FAILURE:
      return {
        ...state,
        authenticating: false,
        authenticatingError: payload,
      };

    case types.LOG_OUT_CHAMPION:
      return {
        ...state,
        championData: null,
      };

    case types.GET_CHAMPION_DATA_REQUEST:
      return {
        ...state,
        gettingChampionData: true,
        gettingChampionDataError: '',
      };

    case types.GET_CHAMPION_DATA_SUCCESS:
      return {
        ...state,
        gettingChampionData: false,
        gettingChampionDataError: '',
        championData: payload,
      };

    case types.GET_POOL_LIST_REQUEST:
      return {
        ...state,
        poolsListLoading: true,
      };
    case types.GET_POOL_LIST_SUCCESS:
      return {
        ...state,
        poolsListLoading: false,
        poolsList: action.payload,
      };
    case types.GET_POOL_LIST_FAILURE:
      return {
        ...state,
        poolsListLoading: false,
        poolsList: action.payload,
      };

    case types.GET_CHAMPION_DATA_FAILURE:
      return {
        ...state,
        gettingChampionData: false,
        gettingChampionDataError: payload,
      };

    case types.SUBMIT_CHAMPION_SOCIAL_FORM_REQUEST:
      return {
        ...state,
        submittingChampionSocialForm: true,
        submittingChampionSocialFormError: '',
      };

    case types.SUBMIT_CHAMPION_SOCIAL_FORM_SUCCESS:
      return {
        ...state,
        submittingChampionSocialForm: false,
        submittingChampionSocialFormError: '',
        submittingChampionSocialFormSuccess: true,
        championData: {
          ...state.championData,
          socials: payload,
        },
      };

    case types.SUBMIT_CHAMPION_SOCIAL_FORM_FAILURE:
      return {
        ...state,
        submittingChampionSocialForm: false,
        submittingChampionSocialFormError: payload,
      };

    case types.CLEAR_CHAMPION_SOCIAL_FORM:
      return {
        ...state,
        submittingChampionSocialForm: false,
        submittingChampionSocialFormError: '',
        submittingChampionSocialFormSuccess: false,
      };

    case types.GET_CHAMPION_PROFILE_DATA_REQUEST:
      return {
        ...state,
        gettingChampionProfileData: true,
        gettingChampionProfileDataError: '',
      };

    case types.GET_CHAMPION_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        gettingChampionProfileData: false,
        gettingChampionProfileDataError: '',
        championProfileData: payload,
      };

    case types.GET_CHAMPION_PROFILE_DATA_FAILURE:
      return {
        ...state,
        gettingChampionProfileData: false,
        gettingChampionProfileDataError: payload,
      };

    case types.GET_CHAMPION_PROFILE_POOLS_REQUEST:
      return {
        ...state,
        gettingChampionProfilePools: true,
        gettingChampionProfilePoolsError: '',
      };

    case types.GET_CHAMPION_PROFILE_POOLS_SUCCESS:
      return {
        ...state,
        gettingChampionProfilePools: false,
        gettingChampionProfilePoolsError: '',
        championProfilePools: payload,
      };

    case types.GET_CHAMPION_PROFILE_POOLS_FAILURE:
      return {
        ...state,
        gettingChampionProfilePools: false,
        gettingChampionProfilePoolsError: payload,
      };

    case types.GET_CHAMPION_POOL_TILES_REQUEST:
      return {
        ...state,
        gettingChampionPoolTiles: true,
        gettingChampionPoolTilesError: '',
      };

    case types.GET_CHAMPION_POOL_TILES_SUCCESS:
      return {
        ...state,
        gettingChampionPoolTiles: false,
        gettingChampionPoolTilesError: '',
        championPoolTiles: payload,
      };

    case types.GET_CHAMPION_POOL_TILES_FAILURE:
      return {
        ...state,
        gettingChampionPoolTiles: false,
        gettingChampionPoolTilesError: payload,
      };

    case types.SUBMIT_CHAMPION_STAKE_FORM_REQUEST:
      return {
        ...state,
        submittingStakeState: {
          ...state.submittingStakeState,
          [action.account]: {
            ...state.submittingStakeState[action.account],
            [action.handle]: {
              ...(state.submittingStakeState[action.account]
                ? state.submittingStakeState[action.account][action.handle]
                : {}),
              submittingStakeForm: true,
              submittingStakeFormError: '',
            },
          },
        },
      };

    case types.SUBMIT_CHAMPION_STAKE_FORM_SUCCESS:
      return {
        ...state,
        submittingStakeState: {
          ...state.submittingStakeState,
          [action.account]: {
            ...state.submittingStakeState[action.account],
            [action.handle]: {
              ...state.submittingStakeState[action.account][action.handle],
              submittingStakeForm: false,
              submittingStakeFormError: '',
              submittingStakeFormSuccess: true,
            },
          },
        },
      };

    case types.SUBMIT_CHAMPION_STAKE_FORM_FAILURE:
      return {
        ...state,
        submittingStakeState: {
          ...state.submittingStakeState,
          [action.account]: {
            ...state.submittingStakeState[action.account],
            [action.handle]: {
              ...state.submittingStakeState[action.account][action.handle],
              submittingStakeForm: false,
              submittingStakeFormError: payload,
            },
          },
        },
      };

    case types.CLEAR_CHAMPION_STAKE_FORM:
      return {
        ...state,
        submittingStakeState: {
          ...state.submittingStakeState,
          [action.account]: {
            ...state.submittingStakeState[action.account],
            [action.handle]: {
              ...state.submittingStakeState[action.account][action.handle],
              submittingStakeForm: false,
              submittingStakeFormError: '',
              submittingStakeFormSuccess: false,
            },
          },
        },
      };

    case types.SET_CHAMPION_HAS_OWN_POOL:
      return {
        ...state,
        championHasOwnPool: payload,
      };

    default:
      return state;
  }
};
